import { Api } from "./api"

const PATH = 'anita'
const ENDPOINTS = {
    TotalClics:'total-clics',
    StatistiquesParDate:'statistiques-par-date',
}

const getTotalClics = (signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.TotalClics}`, signal)
}

const getStatistiquesParDate = (signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.StatistiquesParDate}`, signal)
}

export const anitaApi = {
    getTotalClics,
    getStatistiquesParDate,
}
